import { memo } from 'react';

import { SvgIcon } from '@material-ui/core';

import { SvgIconProps } from './SvgIcon.types';

export const WelcomeOnboardingIcon = memo(({ className, fontSize = 16 }: SvgIconProps) => (
  <SvgIcon
    className={className}
    width="187"
    height="116"
    viewBox="0 0 187 116"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fill: 'none', fontSize }}
  >
    <path
      d="M17.33 112.836V115.325V114.414C17.33 114.657 17.5126 114.839 17.7562 114.839H60.1409C60.3844 114.839 60.5671 114.657 60.5671 114.414V115.325V71.4286L74.2691 76.8322C74.3909 76.8929 74.5126 76.8929 74.6344 76.8322C74.7562 76.7714 74.8171 76.65 74.878 76.5286L74.9998 76.0429L82.7338 79.2607C83.3428 79.5036 83.9517 79.625 84.5607 79.625C85.1697 79.625 85.7787 79.5036 86.3876 79.2607C87.5447 78.775 88.5191 77.8643 89.0062 76.65L100.759 48.4179C100.82 48.2964 100.82 48.175 100.759 48.0536C100.699 47.9322 100.638 47.8714 100.516 47.8107C94.6088 45.3822 87.7883 48.175 85.3524 54.0643L80.6633 65.3572L78.1665 64.325L78.5928 62.8679C78.6537 62.6857 78.5319 62.4429 78.3492 62.3214L52.5896 51.2714L48.8748 47.5679V47.5072V44.0464C51.6152 42.3464 53.3203 39.3714 53.3203 36.1536V31.3572H55.9998C57.9485 31.3572 59.5928 29.7786 59.5928 27.775C59.5928 25.7714 58.0094 24.1929 55.9998 24.1929H53.3203V18.7893C55.2082 19.5786 56.3652 20.2464 56.3652 20.2464C56.5479 20.3679 56.8524 20.3072 56.9742 20.125C57.096 19.9429 57.0351 19.6393 56.8524 19.5179C56.7915 19.5179 55.5126 18.7286 53.3203 17.8179V13.1429C53.3203 8.04288 49.1793 3.91431 44.0639 3.91431H39.6793C34.5639 3.91431 30.4229 8.04288 30.4229 13.1429V18.425C29.8139 18.7893 29.1441 19.1536 28.5351 19.5786C28.3524 19.7 28.2915 20.0036 28.4133 20.1857C28.4742 20.3072 28.6569 20.3679 28.7787 20.3679C28.8396 20.3679 28.9614 20.3679 29.0223 20.3072C29.5094 20.0036 29.9357 19.7 30.4229 19.4572V24.2536H27.7434C25.7947 24.2536 24.1505 25.8322 24.1505 27.8357C24.1505 29.8393 25.7338 31.4179 27.7434 31.4179H30.4229V34.4536C30.4229 37.3072 31.58 40.0393 33.5287 42.0429C33.5287 42.1036 33.5287 42.1036 33.5287 42.1643L33.346 47.5679L31.0319 49.875L14.346 56.0072C9.0479 57.95 5.45496 63.1107 5.45496 68.7572V78.1072V113.079L17.33 112.836Z"
      fill="#F0CBA7"
    />
    <path
      d="M60.1409 115.811H17.7563C17.5127 115.811 17.33 115.628 17.33 115.386V78.5321H5.94215C5.69856 78.5321 5.51587 78.3499 5.51587 78.1071V68.7571C5.51587 63.1106 9.10882 58.0106 14.4069 56.0071L31.0928 49.8142L33.5287 47.3856C33.7114 47.2035 33.955 47.2035 34.1377 47.3856L41.1409 54.3071L48.0832 47.3856C48.2659 47.2035 48.5095 47.2035 48.6922 47.3856L52.5896 51.2713L78.3492 62.4428C78.5319 62.5035 78.6537 62.7463 78.5928 62.9892L74.878 76.5892C74.8171 76.7106 74.7562 76.8321 74.6345 76.8928C74.5127 76.9535 74.3909 76.9535 74.2691 76.8928L60.5672 71.4892V115.386C60.5672 115.628 60.3845 115.811 60.1409 115.811Z"
      fill="#E8EFEA"
    />
    <path
      d="M28.5351 19.5787C29.1441 19.1537 29.8139 18.7894 30.4229 18.4251V13.2037C30.4229 8.10367 34.5639 3.9751 39.6793 3.9751H44.0639C49.1793 3.9751 53.3203 8.10367 53.3203 13.2037V17.9394C55.4518 18.7894 56.7915 19.5787 56.8524 19.6394C57.0351 19.7608 57.096 20.0644 56.9742 20.2465C56.8524 20.4287 56.5479 20.4894 56.3652 20.368C56.2434 20.3072 49.5447 16.3001 41.2018 16.4822C41.08 16.4822 40.9582 16.4822 40.8364 16.4822C40.5928 16.4822 40.2883 16.4822 40.0447 16.543C39.8011 16.543 39.5575 16.6037 39.3139 16.6037C39.1312 16.6037 38.9486 16.6644 38.7659 16.6644C38.2787 16.7251 37.8524 16.7858 37.3652 16.9072C36.878 17.0287 36.3909 17.0894 35.9037 17.2715C35.8428 17.2715 35.7819 17.2715 35.721 17.3322C34.1986 17.7572 32.6152 18.3644 31.0928 19.1537C30.4229 19.518 29.753 19.943 29.0832 20.368C29.0223 20.4287 28.9005 20.4287 28.8396 20.4287C28.7178 20.4287 28.5351 20.368 28.4742 20.2465C28.2915 20.0037 28.3524 19.7001 28.5351 19.5787Z"
      fill="#E8EFEA"
    />
    <path
      d="M177.368 54.2463L160.683 48.0535L158.308 45.6856V40.5249C158.308 40.4642 158.308 40.4642 158.308 40.4035C160.317 38.3392 161.413 35.607 161.413 32.8142V29.7785H164.093C166.042 29.7785 167.686 28.1999 167.686 26.1963C167.686 24.2535 166.102 22.6142 164.093 22.6142H161.413V17.8178C161.9 18.0606 162.327 18.3642 162.814 18.6678C162.997 18.7892 163.301 18.7285 163.423 18.5463C163.545 18.3642 163.484 18.0606 163.301 17.9392C162.692 17.5142 162.022 17.1499 161.413 16.7856V11.5035C161.413 6.40347 157.272 2.2749 152.157 2.2749H147.772C142.657 2.2749 138.516 6.40347 138.516 11.5035V16.2392C136.384 17.0892 135.045 17.8785 134.984 17.9392C134.801 18.0606 134.74 18.3642 134.862 18.5463C134.923 18.6678 135.106 18.7285 135.227 18.7285C135.288 18.7285 135.41 18.7285 135.471 18.6678C135.532 18.6678 136.628 17.9392 138.516 17.2106V22.6142H135.836C133.888 22.6142 132.243 24.1928 132.243 26.1963C132.243 28.1392 133.827 29.7785 135.836 29.7785H138.516V34.5749C138.516 37.7928 140.221 40.7678 142.961 42.4678V45.7463L138.881 49.8142L138.82 49.8749L129.503 54.0642C124.753 56.1892 118.968 61.1678 117.628 66.9963L115.862 77.1963C115.801 77.4392 115.984 77.6213 116.166 77.6821L116.593 77.8035L115.436 82.9035L103.5 80.232C100.455 79.5642 97.3492 80.1106 94.7306 81.7499C92.112 83.3892 90.2851 85.9392 89.6152 88.9749C89.5543 89.2178 89.737 89.4606 89.9197 89.5213L119.82 96.1999C120.186 96.2606 120.551 96.3213 120.856 96.3213C121.769 96.3213 122.622 96.0785 123.413 95.5928C124.509 94.9249 125.24 93.832 125.545 92.6178L128.285 80.5963L129.016 80.7785C129.138 80.7785 129.259 80.7785 129.381 80.7178C129.503 80.657 129.564 80.5356 129.564 80.4142L130.965 73.4928V113.746V113.503C130.965 113.746 131.147 113.928 131.391 113.928H173.775C174.019 113.928 174.202 113.746 174.202 113.503V113.746V93.6499L181.327 93.5892C183.945 93.5285 186.077 91.3428 186.077 88.732V76.2856V66.9356C186.259 61.3499 182.667 56.1892 177.368 54.2463Z"
      fill="#F0CBA7"
    />
    <path
      d="M163.301 17.9393C162.692 17.5143 162.022 17.15 161.413 16.7857V11.5643C161.413 6.46427 157.272 2.33569 152.157 2.33569H147.772C142.657 2.33569 138.516 6.46427 138.516 11.5643V16.3C136.385 17.15 135.045 17.9393 134.984 18C134.801 18.1214 134.74 18.425 134.862 18.6071C134.984 18.7893 135.288 18.85 135.471 18.7286C135.593 18.6678 142.292 14.6607 150.634 14.8428C150.756 14.8428 150.878 14.8428 151 14.8428C151.243 14.8428 151.548 14.8428 151.792 14.9036C152.035 14.9036 152.279 14.9643 152.522 14.9643C152.705 14.9643 152.888 15.025 153.07 15.025C153.558 15.0857 153.984 15.1464 154.471 15.2678C154.958 15.3893 155.445 15.45 155.933 15.6321C155.993 15.6321 156.054 15.6321 156.115 15.6928C157.638 16.1178 159.221 16.725 160.743 17.5143C161.413 17.8786 162.083 18.3036 162.753 18.7286C162.814 18.7893 162.936 18.7893 162.997 18.7893C163.118 18.7893 163.301 18.7286 163.362 18.6071C163.545 18.3036 163.484 18.0607 163.301 17.9393Z"
      fill="#E8EFEA"
    />
    <path
      d="M1.74023 114.657V76.2856H13.5543"
      stroke="#E87524"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M81.5768 52.5465L76.705 64.2643L73.4774 62.9286L70.4935 73.7358L78.7146 77.1358C80.9678 78.0465 83.4646 77.0144 84.439 74.7679L96.1313 46.5358C90.4678 44.1679 83.9518 46.9001 81.5768 52.5465Z"
      stroke="#E87524"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.5543 76.2858V69.0608"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.7563 58.3143C37.2271 58.3143 37.6088 57.9337 37.6088 57.4643C37.6088 56.9948 37.2271 56.6143 36.7563 56.6143C36.2854 56.6143 35.9037 56.9948 35.9037 57.4643C35.9037 57.9337 36.2854 58.3143 36.7563 58.3143Z"
      fill="#226937"
    />
    <path
      d="M36.7563 61.7749C37.2271 61.7749 37.6088 61.3944 37.6088 60.9249C37.6088 60.4555 37.2271 60.075 36.7563 60.075C36.2854 60.075 35.9037 60.4555 35.9037 60.9249C35.9037 61.3944 36.2854 61.7749 36.7563 61.7749Z"
      fill="#226937"
    />
    <path
      d="M36.7563 65.0535C37.2271 65.0535 37.6088 64.673 37.6088 64.2035C37.6088 63.7341 37.2271 63.3535 36.7563 63.3535C36.2854 63.3535 35.9037 63.7341 35.9037 64.2035C35.9037 64.673 36.2854 65.0535 36.7563 65.0535Z"
      fill="#226937"
    />
    <path
      d="M145.519 19.457L143.205 28.0785H148.138"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M174.384 93.1035V113.625C174.384 113.868 174.202 114.05 173.958 114.05H131.574C131.33 114.05 131.147 113.868 131.147 113.625V73.3714L129.747 80.2928C129.747 80.4142 129.625 80.5356 129.564 80.5964C129.442 80.6571 129.32 80.6571 129.199 80.6571L116.288 77.6214C116.045 77.5606 115.923 77.3785 115.984 77.1356L117.75 66.9356V66.8749C119.09 61.1071 124.814 56.1892 129.564 54.0035L138.881 49.8142L138.942 49.7535L143.022 45.6856C143.083 45.6249 143.205 45.5642 143.327 45.5642C143.449 45.5642 143.57 45.6249 143.631 45.6856L145.215 47.2642L150.817 52.4249L157.638 45.6856C157.699 45.6249 157.82 45.5642 157.942 45.5642C158.064 45.5642 158.186 45.6249 158.247 45.6856L160.683 48.1142L177.368 54.3071C182.667 56.2499 186.259 61.4106 186.259 67.0571V76.2856C186.259 76.5285 186.077 76.7106 185.833 76.7106H174.019L174.384 93.1035Z"
      fill="#E8EFEA"
    />
    <path
      d="M142.779 32.5714C142.779 32.5714 147.59 34.4536 150.086 30.9321"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M138.09 18.3642C138.09 18.3642 139.795 16.5428 141.926 16.9071"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M149.112 16.543C149.112 16.543 151.67 16.9073 152.218 18.3644"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M131.33 27.5321H134.436V21.2786H131.33C129.625 21.2786 128.224 22.675 128.224 24.375C128.224 26.1357 129.625 27.5321 131.33 27.5321Z"
      stroke="#E87524"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M159.586 21.2786H156.481V27.5321H159.586C161.291 27.5321 162.692 26.1357 162.692 24.4357C162.753 22.675 161.352 21.2786 159.586 21.2786Z"
      stroke="#E87524"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M165.981 82.4178V71.3071H138.577V108.707H165.981V93.5893" fill="#F0CBA7" />
    <path
      d="M157.09 80.3536L162.022 80.2928V69.1821H134.618V106.582H162.022V91.4643L146.128 91.6464C146.006 85.4536 150.939 80.4143 157.09 80.3536Z"
      stroke="#E87524"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M146.372 51.2714C146.432 51.2714 146.432 51.2714 146.372 51.2714L152.34 45.3214L153.375 44.2893C153.375 44.2286 153.375 44.1679 153.375 44.0464V38.7036H153.07C155.202 36.7607 156.481 34.0286 156.481 30.9929V9.74286C156.481 4.94643 152.522 1 147.711 1H143.327C138.455 1 134.497 4.94643 134.497 9.74286V32.7536C134.497 36.0321 136.324 38.8857 138.942 40.3429V44.1071C138.942 44.1679 138.942 44.2286 138.942 44.35L140.465 45.8679L146.372 51.2714Z"
      stroke="#E87524"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M156.481 15.2679V9.74286C156.481 4.94643 152.522 1 147.711 1H143.327C138.455 1 134.497 4.94643 134.497 9.74286V14.7214C139.307 12.9 148.016 10.7143 156.481 15.2679Z"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M130.782 16.5428C130.782 16.5428 145.458 7.61784 158.612 16.5428"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M111.417 81.5678L99.0543 78.775C93.0255 77.4393 87.0575 81.2036 85.7178 87.1535L115.618 93.8321C117.993 94.3785 120.308 92.8607 120.856 90.5536L123.657 78.1071L112.817 75.5571L111.417 81.5678Z"
      stroke="#E87524"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M138.699 85.0894V89.7644"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M141.074 85.0894V89.7644"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M141.074 87.4573H138.699"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M142.901 85.0894V88.5501C142.901 89.2179 143.449 89.7644 144.118 89.7644C144.788 89.7644 145.336 89.2179 145.336 88.5501V85.0894"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M171.705 76.7106V82.2963L164.215 82.4178L159.282 82.4785C153.131 82.5999 148.199 87.6392 148.32 93.7713L164.215 93.5892L171.705 93.4678L179.256 93.3463C181.692 93.2856 183.58 91.3428 183.519 88.9142V76.6499L171.705 76.7106Z"
      fill="#F0CBA7"
    />
    <path
      d="M169.513 74.5251V80.1108L162.022 80.2322L157.09 80.2929C150.939 80.4144 146.006 85.4536 146.128 91.5858L162.022 91.4036L169.513 91.2822L177.064 91.1608C179.5 91.1001 181.388 89.1572 181.327 86.7286V74.4644L169.513 74.5251Z"
      stroke="#E87525"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M146.311 56.5535C146.782 56.5535 147.163 56.173 147.163 55.7035C147.163 55.2341 146.782 54.8535 146.311 54.8535C145.84 54.8535 145.458 55.2341 145.458 55.7035C145.458 56.173 145.84 56.5535 146.311 56.5535Z"
      fill="#046A37"
    />
    <path
      d="M146.311 60.0142C146.782 60.0142 147.163 59.6337 147.163 59.1642C147.163 58.6948 146.782 58.3142 146.311 58.3142C145.84 58.3142 145.458 58.6948 145.458 59.1642C145.458 59.6337 145.84 60.0142 146.311 60.0142Z"
      fill="#046A37"
    />
    <path
      d="M146.311 63.293C146.782 63.293 147.163 62.9125 147.163 62.443C147.163 61.9736 146.782 61.593 146.311 61.593C145.84 61.593 145.458 61.9736 145.458 62.443C145.458 62.9125 145.84 63.293 146.311 63.293Z"
      fill="#046A37"
    />
    <path
      d="M146.037 51.3158L138.889 44.1892L134.798 48.2677L141.946 55.3942L146.037 51.3158Z"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M153.497 44.168L153.375 44.2894L152.34 45.3215L146.311 51.3323L150.391 55.4001L157.577 48.2965L153.497 44.168Z"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M169.513 74.525H181.327V65.175C181.327 59.7107 177.917 54.7929 172.74 52.85L155.933 46.6572L153.436 44.1679L146.372 51.2107L140.465 45.7465L138.942 44.2286L138.82 44.1072L134.74 48.175L134.801 48.2358L125.24 52.6072C120.247 54.8536 114.888 59.8322 113.67 65.175L111.904 75.375L112.756 75.5572L123.596 78.1072L124.814 78.4108L127.128 67.3V82.175V111.864H169.513V91.3429"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M169.513 74.525V67.3"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M169.513 74.5251H181.327"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M139.917 22.8571C140.455 22.8571 140.891 22.1503 140.891 21.2785C140.891 20.4067 140.455 19.7 139.917 19.7C139.378 19.7 138.942 20.4067 138.942 21.2785C138.942 22.1503 139.378 22.8571 139.917 22.8571Z"
      fill="#046A37"
    />
    <path
      d="M150.635 22.8571C151.173 22.8571 151.609 22.1503 151.609 21.2785C151.609 20.4067 151.173 19.7 150.635 19.7C150.096 19.7 149.66 20.4067 149.66 21.2785C149.66 22.1503 150.096 22.8571 150.635 22.8571Z"
      fill="#046A37"
    />
    <path
      d="M144.057 4.7644V9.43941"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M146.432 4.7644V9.43941"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M146.433 7.07153H144.057"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.8171 6.40356V11.0786"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M39.1921 6.40356V11.0786"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M39.1921 8.71069H36.8171"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M153.07 38.7644C153.07 38.7644 151.426 39.9787 148.807 40.343"
      stroke="#E87524"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M138.942 40.4036C138.942 40.4036 140.404 41.4357 142.718 41.4357"
      stroke="#E87524"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M37.7306 21.1572L39.9838 29.7787H35.0511"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.471 34.2714C40.471 34.2714 35.6601 36.1535 33.1633 32.6321"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.0992 20.0036C45.0992 20.0036 43.3941 18.1822 41.2627 18.5465"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M34.0768 18.1821C34.0768 18.1821 31.5191 18.5464 30.971 20.0036"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M51.8588 29.1715H48.7531V22.918H51.8588C53.564 22.918 54.9646 24.3144 54.9646 26.0144C54.9646 27.7751 53.564 29.1715 51.8588 29.1715Z"
      stroke="#E87524"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.6024 22.918H26.7082V29.1715H23.6024C21.8973 29.1715 20.4967 27.7751 20.4967 26.0751C20.4358 24.3144 21.8364 22.918 23.6024 22.918Z"
      stroke="#E87524"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M37.0608 53.0928H36.7563L30.8492 47.2035L29.6313 45.9285C29.6313 45.8678 29.6313 45.8678 29.6313 45.8071L29.814 40.4035H30.1184C27.987 38.4607 26.7082 35.7285 26.7082 32.6928V11.4428C26.7082 6.64638 30.6665 2.69995 35.4774 2.69995H39.862C44.6729 2.69995 48.6313 6.64638 48.6313 11.4428V34.4535C48.6313 37.7321 46.8043 40.5857 44.1858 42.0428V45.7464C44.1858 45.8071 44.1858 45.8678 44.1858 45.9892L42.6633 47.5071L37.0608 53.0928Z"
      stroke="#E87524"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.7082 16.9073V11.3823C26.7082 6.58583 30.6665 2.6394 35.4774 2.6394H39.862C44.6729 2.6394 48.6313 6.58583 48.6313 11.3823V16.3608C43.9422 14.5394 35.1729 12.3537 26.7082 16.9073Z"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M52.4678 18.1822C52.4678 18.1822 37.7915 9.25724 24.6377 18.1822"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43.2723 24.4965C43.8104 24.4965 44.2466 23.7897 44.2466 22.9179C44.2466 22.0461 43.8104 21.3394 43.2723 21.3394C42.7341 21.3394 42.2979 22.0461 42.2979 22.9179C42.2979 23.7897 42.7341 24.4965 43.2723 24.4965Z"
      fill="#046A37"
    />
    <path
      d="M32.5543 24.4965C33.0924 24.4965 33.5287 23.7897 33.5287 22.9179C33.5287 22.0461 33.0924 21.3394 32.5543 21.3394C32.0162 21.3394 31.58 22.0461 31.58 22.9179C31.58 23.7897 32.0162 24.4965 32.5543 24.4965Z"
      fill="#046A37"
    />
    <path
      d="M30.1793 40.4036C30.1793 40.4036 31.8236 41.6179 34.4421 41.9821"
      stroke="#E87524"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.2467 42.043C44.2467 42.043 42.7851 43.0751 40.471 43.0751"
      stroke="#E87524"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.1878 57.1534L48.3358 50.0269L44.2451 45.9484L37.097 53.075L41.1878 57.1534Z"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.7817 53.0758L29.6337 45.9492L25.5429 50.0277L32.691 57.1542L36.7817 53.0758Z"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M48.1441 49.8749L44.2466 45.9285L37.1216 53.032C37.0607 53.032 36.9998 53.032 36.8781 53.032C36.8172 53.032 36.7563 53.032 36.6345 53.032L29.6313 45.9285L27.1345 48.4178L10.3268 54.6713C5.15049 56.5535 1.74023 61.4713 1.74023 66.9963V76.2856H13.5543V113.564H55.939V83.8749V68.9999L70.2498 74.5856L70.4934 73.6142L73.4774 62.807L73.9646 60.9856L48.1441 49.8749Z"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
));
